// extracted by mini-css-extract-plugin
export var additionalButtons = "PriceModule-module--additionalButtons--23b37";
export var additionalsContainer = "PriceModule-module--additionalsContainer--b3aed";
export var additionalsFirstSection = "PriceModule-module--additionalsFirstSection--fb862";
export var alignRight = "PriceModule-module--alignRight--5850c";
export var btnHide = "PriceModule-module--btnHide--aff6f";
export var creditContainer = "PriceModule-module--creditContainer--6d712";
export var fadeInAnimation = "PriceModule-module--fade-in-animation--47b93";
export var fewInStockText = "PriceModule-module--fewInStockText--5fe52";
export var header = "PriceModule-module--header--4dc84";
export var inStockText = "PriceModule-module--inStockText--c7e09";
export var infoContainer = "PriceModule-module--infoContainer--df1fe";
export var noButtons = "PriceModule-module--noButtons--0fb6e";
export var oddButtonAmount = "PriceModule-module--oddButtonAmount--640ff";
export var oneButton = "PriceModule-module--oneButton--d4e71";
export var outOfStockPrice = "PriceModule-module--outOfStockPrice--64a13";
export var outOfStockText = "PriceModule-module--outOfStockText--d984f";
export var payment = "PriceModule-module--payment--43983";
export var price = "PriceModule-module--price--6d967";
export var priceContainer = "PriceModule-module--priceContainer--2d273";
export var productContainer = "PriceModule-module--productContainer--d3871";
export var rating = "PriceModule-module--rating--0d4da";
export var ratingIcons = "PriceModule-module--ratingIcons--87103";
export var text = "PriceModule-module--text--a63c8";
export var title = "PriceModule-module--title--092b0";
export var wrapper = "PriceModule-module--wrapper--a36bc";